export default __webpack_public_path__ + "static/media/img_1128conv_large_1.2d93b904.jpg";